import { ITitle } from 'services/types';

export const getMainTitle = (mainTitle?: ITitle) =>
  mainTitle
    ? `${mainTitle.title} ${
        mainTitle.version ? `  -  ${mainTitle.version}` : ''
      } `
    : '-';

export const trimTitle = (title: ITitle): ITitle => ({
  ...title,
  title: title.title.trim(),
  version: title?.version?.trim(),
});

export const trimTitles = (titles?: ITitle[]): ITitle[] =>
  titles?.map(t => trimTitle(t)) ?? [];
